<template lang="pug">
form
  .row
    .col-md-8
      div.row
        div.col-md-1.col-xs-1.ic_mail
          //- i.material-icons email
          img(src="../../assets/images/faces/ic_mail.svg")
        div.col-md-11.col-xs-11(style="padding-left:15px")
          span.p-content {{user.email}}
      div.row
        div.col-md-1.col-xs-1.ic_phone
          //- i.material-icons settings_phone
          img(src="../../assets/images/faces/ic_phone.svg")
        div.col-md-11.col-xs-11(style="padding-left:15px")
          span.p-content(v-if="user.phone_number !== '' && user.phone_number !== null") {{user.phone_number}}
          span.p-content(v-else) Chưa cập nhật
      div.row
        div.col-md-1.col-xs-1.ic_caledar
          //- i.material-icons calendar_today
          img(src="../../assets/images/faces/ic_calendar.svg")
        div.col-md-11.col-xs-11(style="padding-left:15px")
          span.p-content Đã tham gia tháng {{getMonth()}} năm {{getYear()}}
      div.row
        div.col-md-1.col-xs-1.ic_birthday
          //- i.material-icons cake
          img(src="../../assets/images/faces/ic_birthday.svg")
        div.col-md-11.col-xs-11(style="padding-left:15px")
          span.p-content(v-if="user.birthday !== '' && user.birthday !== null") Sinh vào {{fmDate()}}
          span.p-content(v-else) Chưa cập nhật
      div.nowrap.row
        div.col-md-1.col-xs-1.ic_school
          //- i.material-icons house
          img(src="../../assets/images/faces/ic_school.svg")
        div.col-md-11.col-xs-11(style="padding-left:15px")
          span.p-content(v-if="user.type_user === 2") 
            span(v-if="school && school.length > 0") Công tác tại {{school && school.length > 0 && school[0].name || ''}}
            span(v-else) Chưa cập nhật
          span.p-content(v-if="user.type_user === 1")
            span(v-if="school && school.length > 0") Học tập tại {{school && school.length > 0 && school[0].name || ''}}
            span(v-else) Chưa cập nhật
          span.p-content(v-if="user.type_user === 1")
            span(v-if="grade && grade.length > 0")  - Học sinh khối {{grade && grade.length > 0 && grade[0].name || ''}}
            span(v-else)  - Chưa cập nhật
</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'

export default {
  props: {
    user: Object
  },
  data() {
    return {
      school: null,
      grade: null
    }
  },
  methods: {
    getMonth() {
      // console.log(this.user)
      const d = new Date(this.user.created_at)
      return ('0' + (d.getMonth() + 1)).slice(-2)
    },
    getYear() {
      const d = new Date(this.user.created_at)
      return d.getFullYear()
    },
    fmDate() {
      const d = new Date(this.user.birthday)
      var day = ('0' + d.getDate()).slice(-2)
      var month = ('0' + (d.getMonth() + 1)).slice(-2)
      var year = d.getFullYear()
      return day + '/' + month + '/' + year
    }
  },
  apollo: {
    school: {
      query: gql(graphql.GET_SCHOOL_ID),
      variables() {
        return {
          sid: this.user.school_id || 0
        }
      },
      update: data => {
        return data.school
      }
    },
    grade: {
      query: gql(graphql.GET_GRADE_ID),
      variables() {
        return {
          gid: this.user.grade_id && this.user.grade_id.length > 0 && this.user.grade_id[0] || 0
        }
      },
      update: data => {
        return data.grades
      }
    }
  }
}
</script>
<style lang="scss">
.nowrap {
  white-space: nowrap !important;
}

.ic_phone,.ic_caledar,.ic_birthday,.ic_school
.ic_mail {
  img {width: 16px; height: 16px;}
}

@media (max-width: 414px) {
  .nowrap {
    white-space: normal !important;
  }
}

@media only screen 
    and (device-width : 375px) 
    and (device-height : 812px) 
    and (-webkit-device-pixel-ratio : 3) { 
  .col-xs-1 {
    padding-right:9px! important;
  }
}

@media only screen 
    and (device-width : 375px) 
    and (device-height : 667px)  { 
  .col-xs-1 {
    padding-right:9px! important;
  }
}

@media only screen 
    and (device-width : 320px) 
    and (device-height : 568px)  { 
  .col-xs-1 {
    padding-right:8px! important;
  }
}

@media only screen 
    and (device-width : 360px) 
    and (device-height : 640px)  { 
  .col-xs-1 {
    padding-right:11px! important;
  }
}
</style>



// WEBPACK FOOTER //
// UserInfo.vue?23857e82